export default function QuestionSelling({ register, errors }) {
  const fieldName = "questionselling";

  const options = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  return (
    <fieldset>
      <legend className="wdc-field-label">
        Will you be selling things on the site?
      </legend>

      <div className="space-y-2.5">
        {options.map((item) => (
          <label
            key={item.value}
            htmlFor={`${fieldName}-${item.value}`}
            className="wdc-option"
          >
            <input
              id={`${fieldName}-${item.value}`}
              type="radio"
              className="wdc-check"
              value={item.value}
              {...register(`${fieldName}`, { required: true })}
            />
            <span className="wdc-option-label">{item.label}</span>
          </label>
        ))}

        {errors[fieldName] && (
          <span className="wdc-error">This field is required</span>
        )}
      </div>
    </fieldset>
  );
}
